import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../axiosConfig';
import './InvitationAcceptance.css';

interface InvitationData {
  email: string;
  offeringId: string;
  offeringName: string;
  role: string;
  invitedBy: string;
}

const InvitationAcceptance: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [invitation, setInvitation] = useState<InvitationData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchInvitation = async () => {
      try {
        const response = await axios.get(`/api/invitations/accept/${token}`);
        setInvitation(response.data);
      } catch (err: any) {
        setError(err.response?.data?.error || 'Invalid or expired invitation');
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      fetchInvitation();
    }
  }, [token]);

  const handleAcceptInvitation = () => {
    if (invitation) {
      // Navigate to dashboard with member form open and pre-filled data
      navigate(`/?form=member&fromInvitation=true&email=${encodeURIComponent(invitation.email)}&offering=${encodeURIComponent(invitation.offeringName)}`);
    }
  };

  if (loading) {
    return (
      <div className="invitation-page">
        <div className="invitation-card">
          <div className="loading-spinner">Loading invitation...</div>
        </div>
      </div>
    );
  }

  if (error || !invitation) {
    return (
      <div className="invitation-page">
        <div className="invitation-card error-card">
          <div className="error-icon">⚠️</div>
          <h2>Invalid Invitation</h2>
          <p>{error || 'This invitation link is not valid'}</p>
          <button onClick={() => navigate('/')} className="btn-primary">
            Go to Homepage
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="invitation-page">
      <div className="invitation-card">
        <div className="invitation-header">
          <div className="invitation-icon">✉️</div>
          <h1>You're Invited!</h1>
        </div>

        <div className="invitation-body">
          <p className="invitation-intro">
            <strong>{invitation.invitedBy}</strong> has invited you to join the Dream Directory as a{' '}
            <span className="role-badge">{invitation.role}</span> for:
          </p>

          <h2 className="offering-name">{invitation.offeringName}</h2>

          <p className="invitation-details">
            By accepting this invitation, you'll create your member profile and join this offering in the Dream Directory community.
          </p>

          <div className="invitation-email">
            <p>Invitation sent to:</p>
            <strong>{invitation.email}</strong>
          </div>
        </div>

        <div className="invitation-actions">
          <button onClick={handleAcceptInvitation} className="btn-accept">
            Accept Invitation & Create Profile
          </button>
          <button onClick={() => navigate('/')} className="btn-secondary">
            View Directory
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvitationAcceptance;
